import { Genre } from '../models/genre';
import {useLanguageIndependentData} from './useLanguageIndependentData.hook';

export const useGenres = useLanguageIndependentData<Genre[]>('genres');
